// import PaginatedList from '@theme/paginated-list';

// /**
//  * A custom element that renders a paginated blog posts list
//  */
// export default class BlogPostsList extends PaginatedList {}

// if (!customElements.get('blog-posts-list')) {
//   customElements.define('blog-posts-list', BlogPostsList);
// }

class BlogPostsList extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
  }

  connectedCallback() {
    this.grid = this.querySelector('[ref="grid"]');
    this.loadMoreBtn = this.querySelector('[js-load-more-btn]');

    if (!this.grid || !this.loadMoreBtn) return;

    this.loadMoreBtn.addEventListener('click', this.handleLoadMore);
  }

  disconnectedCallback() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.removeEventListener('click', this.handleLoadMore);
    }
  }

  handleLoadMore = async () => {
    if (this.isLoading) return;

    const nextUrl = this.grid.dataset.nextUrl;
    if (!nextUrl) {
      this.loadMoreBtn.style.display = 'none';
      return;
    }

    this.isLoading = true;
    this.loadMoreBtn.disabled = true;
    this.loadMoreBtn.querySelector('span').textContent = 'loading...';

    try {
      const response = await fetch(nextUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) throw new Error('Failed to fetch next page');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('[ref="grid"]');
      const newItems = newGrid?.querySelectorAll('.blog-post-item');

      if (newItems && newItems.length) {
        newItems.forEach((item) => {
          this.grid.appendChild(item);
        });
      }

      const newNextUrl = newGrid?.dataset.nextUrl;

      if (newNextUrl) {
        this.grid.dataset.nextUrl = newNextUrl;
      } else {
        this.grid.dataset.nextUrl = '';
        this.loadMoreBtn.style.display = 'none';
      }
    } catch (error) {
      console.error('Load more failed:', error);
    } finally {
      this.isLoading = false;
      this.loadMoreBtn.disabled = false;
      this.loadMoreBtn.querySelector('span').textContent = 'load more';
    }
  };
}

customElements.define('blog-posts-list', BlogPostsList);